import { CMultiSelect } from './CMultiSelect.js';

const CMultiSelectPlugin = {
    install: (app) => {
        app.component(CMultiSelect.name, CMultiSelect);
    },
};

export { CMultiSelect, CMultiSelectPlugin };
//# sourceMappingURL=index.js.map
